import gql from 'graphql-tag';

export const registerChangePhotoRequestProcedure = gql`
  mutation registerChangePhotoRequestProcedure(
    $period: String!
    $imgBase64: String!
    $fileType: String!
    $procedureId: Float!
  ) {
    registerChangePhotoRequestProcedure(
      period: $period
      imgBase64: $imgBase64
      fileType: $fileType
      procedureId: $procedureId
    ) {
      error
      requestId
    }
  }
`;

export const cancelChangePhotoRequestProcedure = gql`
  mutation cancelRequestProcedure($requestId: Float!, $procedureId: Float!) {
    cancelRequestProcedure(requestId: $requestId, procedureId: $procedureId) {
      error
      requestId
    }
  }
`;
